import $ from 'jquery';
import _ from 'underscore';
import App from '../app.js';
import ScrollMagic from 'scrollmagic';
var Quote = function(){

	var $section = $('#Quote');
	if( $section.length < 1 ) return false;
	var activeClass = 'is-active',
			controller = App.getScrollMagicController(),
			quoteList = window.quoteList,
			quoteTemplate = _.template( $('#QuoteTemplate').html() ),
			$body = $section.find('.js-body');

	var scene =	new ScrollMagic.Scene({
				triggerElement: $section[0],
				duration: '50%',
				triggerHook: 0.75,
			})
			.setClassToggle( $section[0], activeClass) // add class toggle
			// .addIndicators() // add indicators (requires plugin)
			.addTo(controller)
			.reverse(true);

	renderRandomQuote();

	function renderRandomQuote() {
		var data = getRandomArrayValue( quoteList );
		console.log(data);
		var quoteMarkup = quoteTemplate(data);
		$body.html( quoteMarkup );
	}

	function getRandomArrayValue( myArray ) {
  	 return myArray[Math.floor(Math.random() * myArray.length)];
	}

};

export default Quote();